// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_h04dt","foot_link":"index_foot_link_DbXOh clearfix","fk_l":"index_fk_l_fStCg","link":"index_link_y8Fn-","copyright":"index_copyright_BFDYm"};